import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import React, { useCallback, useState } from 'react';
import { CompassOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { loadExperiments, setActiveExperiment } from 'redux/actions/experiments';
import { modules } from 'const';
import { useAppRouter } from 'utils/AppRouteProvider';
import fetchAPI from 'utils/http/fetchAPI';
import sendInvites from 'utils/data-management/experimentSharing/sendInvites';
import pushNotificationMessage from 'utils/pushNotificationMessage';

// eslint-disable-next-line react/prop-types
var DropdownLabel = function DropdownLabel(_ref) {
  var title = _ref.title,
    description = _ref.description,
    key = _ref.key;
  return __jsx("div", {
    "aria-label": key,
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      maxWidth: '450px',
      whiteSpace: 'normal',
      wordWrap: 'break-word'
    }
  }, __jsx("span", null, title), __jsx("span", {
    style: {
      marginLeft: '10px',
      color: 'gray'
    }
  }, description));
};
var ExploreSelect = function ExploreSelect(props) {
  var experiment = props.experiment;
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var dispatch = useDispatch();
  var userEmail = useSelector(function (state) {
    return state.user.current.attributes.email;
  });
  var _useState = useState(false),
    isViewing = _useState[0],
    setIsViewing = _useState[1];
  var _useState2 = useState(false),
    isCloning = _useState2[0],
    setIsCloning = _useState2[1];
  var isLoading = isViewing || isCloning;
  var addAsViewer = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          setIsViewing(true);
          _context.next = 4;
          return sendInvites([userEmail], {
            id: experiment.id,
            name: experiment.name,
            role: 'viewer'
          }, true);
        case 4:
          _context.next = 6;
          return dispatch(loadExperiments());
        case 6:
          _context.next = 8;
          return dispatch(setActiveExperiment(experiment.id));
        case 8:
          navigateTo(modules.DATA_EXPLORATION, {
            experimentId: experiment.id
          });
        case 9:
          _context.prev = 9;
          setIsViewing(false);
          return _context.finish(9);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0,, 9, 12]]);
  })), [experiment.id, userEmail]);
  var cloneExperiment = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var url, newExperimentId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          setIsCloning(true);
          pushNotificationMessage('loading', 'Creating your copy… This may take a few moments', 'clone', 0);
          url = "/v2/experiments/".concat(experiment.id, "/clone");
          _context2.next = 6;
          return fetchAPI(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 6:
          newExperimentId = _context2.sent;
          _context2.next = 9;
          return dispatch(loadExperiments());
        case 9:
          _context2.next = 11;
          return dispatch(setActiveExperiment(newExperimentId));
        case 11:
          pushNotificationMessage('success', 'Copy created successfully.', 'clone');
          navigateTo(modules.DATA_MANAGEMENT, {
            experimentId: newExperimentId
          });
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](0);
          pushNotificationMessage('error', 'Failed to create copy. Please try again.', 'clone');
        case 18:
          _context2.prev = 18;
          setIsCloning(false);
          return _context2.finish(18);
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 15, 18, 21]]);
  })), [experiment.id]);
  var menuItems = [{
    key: 'view',
    onClick: addAsViewer,
    disabled: isLoading,
    label: __jsx(DropdownLabel, {
      key: "view",
      title: "View",
      description: 'Viewers can explore all aspects of the project including ' + 'data processing settings and plots, clusters and UMAPs, ' + 'differential expression and a variety of plot visualizations. ' + 'However, Viewers cannot change settings or clusters.'
    })
  }, {
    key: 'copy',
    onClick: cloneExperiment,
    disabled: isLoading,
    label: __jsx(DropdownLabel, {
      key: "clone",
      title: "Copy",
      description: 'By creating a copy, you will become the project Owner. ' + 'Owners have full control over data processing settings, ' + 'clusters including the generation of custom clusters, ' + 'and all changes are saved. Note that copying large projects ' + 'can take some time.'
    })
  }];
  return __jsx(_Tooltip, {
    title: "Explore"
  }, __jsx(_Dropdown, {
    menu: {
      items: menuItems
    },
    trigger: ['click'],
    disabled: isLoading
  }, __jsx(_Button, {
    type: "primary",
    icon: __jsx(CompassOutlined, null),
    loading: isLoading,
    "aria-label": "Explore"
  })));
};
ExploreSelect.defaultProps = {};
export default ExploreSelect;